import styled from "styled-components";
import {
  Card,
  CardContent,
  CardMedia,
  Type,
} from "@ebscois/react-component-library";

export const AlgorithmCard = styled(Card)`
  margin: ${({ theme }) => theme.space.md} 0;
  cursor: ${({ isMediaClickDisabled }) =>
      isMediaClickDisabled ? "default" : "pointer"}
    ${({ $hideInlineVideoPrint }) =>
      $hideInlineVideoPrint &&
      `@media print {
      display: none !important;
    }`};
  @media print {
    display: block;
  }
`;

export const AlgorithmContent = styled(CardContent)`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-left: 0;
  }
  @media print {
    display: none;
  }
`;

export const AlgorithmMedia = styled(CardMedia)`
  min-width: 6rem;
  max-width: 6rem;
  margin: 0 auto;

  && div {
    display: flex;
    align-items: flex-start;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex: none;
  }
`;

export const AlgorithmMediaImage = styled.img`
  max-height: 10rem;
  max-width: 100%;
  min-width: 55px;
  min-height: 55px;
  @media print {
    max-height: 15rem;
  }
`;

export const AlgorithmDescription = styled(Type)`
  &&:not(:first-child) {
    margin-top: 0.25rem;
  }
`;

export const AlgorithmTextWrapper = styled.span`
  display: inline-block;
  text-align: left;
`;

export const AlgorithmPDFText = styled.span`
  color: ${({ theme }) => theme.colors.primary.base};
  padding-left: ${({ theme }) => theme.space.xs};
  font-weight: ${({ theme }) => theme.font.weight.normal};
`;
